var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 3C8.1125 3 2.5 8.6125 2.5 15.5C2.5 22.3875 8.1125 28 15 28C21.8875 28 27.5 22.3875 27.5 15.5C27.5 8.6125 21.8875 3 15 3ZM20.975 12.625L13.8875 19.7125C13.7125 19.8875 13.475 19.9875 13.225 19.9875C12.975 19.9875 12.7375 19.8875 12.5625 19.7125L9.025 16.175C8.6625 15.8125 8.6625 15.2125 9.025 14.85C9.3875 14.4875 9.9875 14.4875 10.35 14.85L13.225 17.725L19.65 11.3C20.0125 10.9375 20.6125 10.9375 20.975 11.3C21.3375 11.6625 21.3375 12.25 20.975 12.625Z",
    fill: "#23A26D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.0fc83c2f206b933e81aa9216d712bbbd.svg";
export { ForwardRef as ReactComponent };